module.exports = __webpack_public_path__ + "img/icon_fuori_servizio.362f5346.png";